export default __webpack_public_path__ + "5eac55688567f37e37822f9e3209f04d.svg";